export enum FormDisplay {
  Modal = 'modal',
  Side = 'side',
}
